export default __webpack_public_path__ + "static/media/BrainBreak cards87.bb218e4d.png";